<template>
  <div class="content-box" data-app>
    <v-data-table
      :headers="headers"
      :items="selectedResults"
      item-key="object_uuid"
      :loading="loading"
      loading-text=""
      :items-per-page-text="$t('tables.RowsPerPage')"
      :items-per-page-items="[5, 10, 25, { text: $t('All'), value: -1 }]"
      :header-props="{ sortIcon: 'mdi-menu-down' }"
      :footer-props="{ prevIcon: 'mdi-menu-left', nextIcon: 'mdi-menu-right' }"
      style="width: 100%"
      :value="selected"
      class="elevation-2"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.object_type_label }}</td>
          <td>{{ props.item.object_id }}</td>
          <td>{{ props.item.error_message }}</td>
          <td class="location-icon-container">
            <v-btn icon text color="accent" @click="viewInMap(props.item)">
              <v-icon>gps_fixed</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "ErrorSelection",

  props: {
    selectedResults: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      search: "",
      selected: []
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$i18n.tc("Type", 1),
          align: "left",
          value: "object_type_label",
          width: "15%"
        },
        {
          text: this.$i18n.t("ID"),
          align: "left",
          value: "object_id",
          width: "10%"
        },
        {
          text: this.$i18n.t("Description"),
          align: "left",
          value: "error_message",
          width: "60%"
        },
        {
          text: this.$i18n.t("Location"),
          align: "center",
          value: "object_geojson",
          width: "20%"
        }
      ];
    }
  },

  methods: {
    /**
     * View object centered and zoomed in in the map of the OSP tab
     */
    viewInMap(item) {
      this.selected = [item];
      let location = item.object_geojson;
      this.$store.dispatch("SET_OBJECT_TO_ZOOM_ON_MAP", undefined).then(() => {
        this.$store.dispatch("SET_OBJECT_TO_ZOOM_ON_MAP", location).then(() => {
          let layoutMode = this.$store.getters.getActiveLayoutMode;
          if (layoutMode === 1) {
            this.$store.dispatch("SET_ACTIVE_FIBERCLOUD_TAB", "home");
          }
        });
      });
    }
  },

  watch: {
    selectedResults() {
      this.selected = [];
    }
  }
};
</script>

<style scoped>
.location-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.location-icon path {
  fill: grey;
}
.location-icon:hover path {
  fill: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Validations/ErrorSelection/ErrorSelection.vue